<template>
    <alert-modal
        :title="$t('TIMEOUT_TITLE')"
        :primaryCTAText="$t('ACTION_CONTINUE')"
        :secondaryCTAText="$t('ACTION_END_SESSION')"
        :blue="true"
        @close="close"
        @cancel="endNow"
        @confirm="close"
        @overlayClick="close"
        data-cz-component="timeoutWarning"
        class="cz2__timeout-warning"
    >
        <div class="cz2__modal-popup__content">
            {{$t('TIMEOUT_EXPIRE')}}
        </div>

        <div
            v-if="lastChanceMinutesLeft != null && lastChanceSecondsLeft != null && !isNaN(lastChanceMinutesLeft)"
            class="cz2__timeout-warning__time"
        >
            {{lastChanceMinutesLeft}}:{{lastChanceSecondsLeft.toString().padStart(2, '0')}}
        </div>
    </alert-modal>
</template>

<style lang="scss">
    @import '../style/variables';

    #cz2.cz2 {
        .cz2__timeout-warning {
            position: absolute;
            z-index: 100000;
        }

        .cz2__timeout-warning__time {
            margin-bottom: 32px;

            @include font(feature);
            color: color(primaryBlue);

            text-align: center;
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__timeout-warning__time {
            font-size: 73px;
            line-height: 50px;
            margin-top: 66.5px;
            margin-bottom: 66.5px;
        }
    }
</style>

<script>
    import AlertModal from './ui/AlertModal.vue';

    export default {
        components: {
            AlertModal,
        },
        data() {
            return {
                lastChanceMinutesLeft: null,
                lastChanceSecondsLeft: null,
            };
        },

        computed: {
            /**
             * Current configuration.
             */
            configuration() {
                if (this.$store.state.customizer.options == null) {
                    return {};
                }

                return this.$store.state.customizer.options.configuration || {};
            },
        },

        mounted() {
            this.startLastChanceTimeout();
        },

        beforeDestroy() {
            this.clearLastChanceTimeout();
        },

        methods: {
            close() {
                this.$store.dispatch('log', {
                    level: 'info',
                    message: 'Idle timeout popup was closed',
                });

                this.$store.dispatch('showTimeoutWarning', false);
            },

            clearLastChanceTimeout() {
                if (this.lastChanceTimer) {
                    clearInterval(this.lastChanceTimer);
                    this.lastChanceTimer = null;
                }
            },

            startLastChanceTimeout() {
                this.clearLastChanceTimeout();

                this.lastChanceExpiresOn = new Date().getTime() + this.configuration.idleTimeoutLastChance;

                this.$store.dispatch('log', {
                    level: 'info',
                    message: `Starting last chance timeout for ${this.configuration.idleTimeoutLastChance}ms`,
                });

                this.checkLastChanceExpired();

                this.lastChanceTimer = setInterval(() => {
                    this.checkLastChanceExpired();
                }, 250);
            },

            endNow() {
                this.$store.dispatch('log', {
                    level: 'info',
                    message: 'Ending session immediately',
                });

                this.resetSession();
            },

            resetSession() {
                this.clearLastChanceTimeout();

                this.$store.dispatch('showTimeoutWarning', false);

                window.location.reload();

                // this.$store.dispatch('resetCustomizations');
            },

            checkLastChanceExpired() {
                const now = new Date().getTime();
                const left = this.lastChanceExpiresOn - now;

                // Expired.
                if (left <= 0) {
                    this.$store.dispatch('log', {
                        level: 'info',
                        message: 'Last chance timeout expired',
                    });

                    this.resetSession();
                } else {
                    this.lastChanceMinutesLeft = Math.floor((left / 1000) / 60);
                    this.lastChanceSecondsLeft = Math.floor((left / 1000) % 60);
                }
            },
        },
    };
</script>
